// extracted by mini-css-extract-plugin
export default {"ContactUsTextWrapper":"contactUs_ContactUsTextWrapper__b+xcs","borderBox":"contactUs_borderBox__i1tjY","buttonContainer":"contactUs_buttonContainer__wyv1E"};